export default __webpack_public_path__ + "static/media/arrow-down.b5ccd8dc.svg";